import ReactPlayer from "react-player";
import YouTubePlayer from "react-player/youtube";
import { styled } from "styled-components";

export const MediaContainer = styled.div`
  position: relative;
  background-color: black;
  max-height: 100%;

  // padding-top: 50% magically allows the video player to size itself
  // according to its actual size. However, it also means that because this
  // element doesn't have any actual height then it doesn't get constrained by
  // the max-height from above. Hence we use a trick from StackOverflow
  // (https://stackoverflow.com/a/51973507/4489717) to put the padding in a
  // pseudo-element so that it does form part of the element's height, letting
  // the max-height of parent elements affect it.

  &::before {
    content: "";
    display: block;
    padding-top: 50%;
  }

  iframe,
  video {
    border-radius: 5px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
  }
`;

export type WebFrameProps = {
  className?: string;
  forceIframe?: boolean; // TODO: i would advide to split this component later into multiple components for each player type
  height?: number;
  html?: string | null;
  onEnded?: () => void;
  onPauseOrPlay?: () => void;
  title: string;
  url?: string;
  isYoutubeVideo?: boolean;
  width?: number;
};

export const WebFrame = ({
  className,
  url,
  html,
  title,
  onEnded,
  onPauseOrPlay,
  isYoutubeVideo,
  forceIframe,
}: WebFrameProps) => {
  if (html) {
    const htmlMinusFullscreen = html.replace("allowfullscreen", "");
    return <MediaContainer className={className} dangerouslySetInnerHTML={{ __html: htmlMinusFullscreen }} />;
  }

  // If forceIframe is true, render a plain iframe (e.g., for dashboards, visualizations)
  // TODO: this whole MediaPlayer situation needs a big rewrite - I wasn't able to do it as part of this release as I think there needs to be a discussion between BE and FE on this
  if (forceIframe)
    return (
      <MediaContainer className={className}>
        <iframe src={url} title={title} allowFullScreen />
      </MediaContainer>
    );

  if (isYoutubeVideo)
    return (
      <MediaContainer className={className}>
        <YouTubePlayer
          config={{ playerVars: { rel: 0 } }}
          controls
          onEnded={onEnded}
          onPause={onPauseOrPlay}
          onPlay={onPauseOrPlay}
          url={url}
        />
      </MediaContainer>
    );

  return (
    <MediaContainer className={className}>
      <ReactPlayer controls title={title} onEnded={onEnded} onPause={onPauseOrPlay} onPlay={onPauseOrPlay} url={url} />
    </MediaContainer>
  );
};
